import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCentralByLoja } from "./services";
import { TCentral } from "./types";

interface IInitialState {
  status: "error" | "success" | "loading" | "",
  centralSelected: TCentral | undefined | null,
  data: Array<TCentral>,
}

const initialState = {} as IInitialState;

export const actionGetCentralByLoja: any = createAsyncThunk<any, string>(
  "ACTION_GET_CENTRAL_BY_LOJA",
  async (_, { getState }: any) => {
    const {
      getLojas: { lojaSelected },
    } = getState();
    return getCentralByLoja(lojaSelected);
  }
);

const sliceGetCentralByLoja = createSlice({
  name: "GET_CENTRAL",
  initialState,
  reducers: {
    actionSelectCentral: (state, { payload }) => {
      state.centralSelected = state.data.find(
        ({ id }) => id === Number(payload)
      );
    },
    actionResetCentral: (state) => {
      state.status = ""
      state.centralSelected = null;
      state.data = []
    },
  },
  extraReducers: {
    [actionGetCentralByLoja.pending]: (state) => {
      state.status = "loading";
    },
    [actionGetCentralByLoja.fulfilled]: (state, { payload }) => {
      state.status = "success";
      state.data = payload;
    },
    [actionGetCentralByLoja.rejected]: (state) => {
      state.status = "error";
    },
  },
});

export default sliceGetCentralByLoja.reducer;
export const { actionSelectCentral, actionResetCentral } = sliceGetCentralByLoja.actions;
